/* File: assets/technical-library.js */
(() => {
  // Prevent duplicate init per section id (theme editor can re-render sections)
  window.__TL_INIT__ = window.__TL_INIT__ || {};

  function initTechnicalLibrary(sectionId) {
    if (!sectionId) return;

    const root = document.getElementById(`shopify-section-${sectionId}`);
    if (!root) return;

    // If already initialised for this current DOM instance, skip
    if (window.__TL_INIT__[sectionId]) return;
    window.__TL_INIT__[sectionId] = true;

    const dataEl = document.getElementById(`TLData-${sectionId}`);
    const resultsEl = document.getElementById(`TLResults-${sectionId}`);
    const pagerEl = document.getElementById(`TLPager-${sectionId}`);
    const searchEl = document.getElementById(`TLSearch-${sectionId}`);
    const loaderEl = document.getElementById(`TLLoader-${sectionId}`);
    const countEl = document.getElementById(`TLCount-${sectionId}`);
    const activeLabelEl = document.getElementById(`TLActiveLabel-${sectionId}`);
    const tabs = Array.from(root.querySelectorAll('.tl-tab'));

    const configRoot = root.querySelector('[data-tl]');
    const perPage = Number(configRoot?.getAttribute('data-per-page')) || 20;
    const MIN_CHARS = Number(configRoot?.getAttribute('data-min-chars')) || 2;
    const docMode = (configRoot?.getAttribute('data-doc-mode') || 'full').trim(); // 'full' | 'sds_tds' | 'tests'

    let data = { everest: [], everflor: [], summitseal: [] };
    let activeKey = 'everest';
    let activeName = 'Everest';
    let page = 1;
    let filtered = [];
    let hasSearch = false;

    function normaliseImg(url) {
      if (!url) return null;
      if (url.startsWith('//')) return 'https:' + url;
      return url;
    }

    function setLoading(on) {
      loaderEl?.classList.toggle('is-visible', !!on);
    }

    function iconSvg(kind) {
      if (kind === 'tds') return `
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M7 3h7l3 3v15a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z" stroke="currentColor" stroke-width="2"/>
          <path d="M14 3v4h4" stroke="currentColor" stroke-width="2"/>
          <path d="M8 12h8M8 16h6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>`;
      if (kind === 'sds') return `
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 3 2.5 20h19L12 3Z" stroke="currentColor" stroke-width="2"/>
          <path d="M12 9v5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M12 17h.01" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
        </svg>`;
      if (kind === 'guide') return `
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4 5a2 2 0 0 1 2-2h12v16H6a2 2 0 0 0-2 2V5Z" stroke="currentColor" stroke-width="2"/>
          <path d="M18 19H6a2 2 0 0 0-2 2" stroke="currentColor" stroke-width="2"/>
          <path d="M8 7h7M8 11h7M8 15h5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>`;
      if (kind === 'colours') return `
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 3a9 9 0 1 0 0 18h2a2 2 0 0 0 0-4h-1a2 2 0 0 1 0-4h2a2 2 0 0 0 0-4h-1a2 2 0 0 1 0-4h1" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M7.5 10.5h.01M10 8.5h.01M10 12.5h.01" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
        </svg>`;
      return `
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M12 3l7 4v6c0 5-3 8-7 8s-7-3-7-8V7l7-4Z" stroke="currentColor" stroke-width="2"/>
          <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
    }

    function docList(files) {
      // If we’re in tests mode, never render doc tiles
      if (docMode === 'tests') {
        return '';
      }

      const defsAll = [
        { key: 'tds', kind: 'tds', cls: 'tl-doc--tds', label: 'TDS', sub: 'Technical Data Sheet' },

        { key: 'sds_standard', kind: 'sds', cls: 'tl-doc--sds', label: 'SDS', sub: 'Safety Data Sheet' },
        { key: 'sds_resin', kind: 'sds', cls: 'tl-doc--sds', label: 'Resin SDS', sub: 'Safety Data Sheet – Resin' },
        { key: 'sds_hardener', kind: 'sds', cls: 'tl-doc--sds', label: 'Hardener SDS', sub: 'Safety Data Sheet – Hardener' },
        { key: 'sds_aggregate', kind: 'sds', cls: 'tl-doc--sds', label: 'Aggregate SDS', sub: 'Safety Data Sheet – Anti-Slip Aggregate' },

        { key: 'application_guide', kind: 'guide', cls: 'tl-doc--info', label: 'Guide', sub: 'Application Guide' },
        { key: 'colour_chart', kind: 'colours', cls: 'tl-doc--info', label: 'Colours', sub: 'Colour Chart' },
        { key: 'certification', kind: 'cert', cls: 'tl-doc--info', label: 'Cert', sub: 'Certification / Compliance' }
      ];

      const defs = (docMode === 'sds_tds')
        ? defsAll.filter(d => d.key === 'tds' || d.key.startsWith('sds_'))
        : defsAll;

      const safeUrl = (u) => (typeof u === 'string' && u.trim().length ? u.trim() : null);

      const item = (def, url) => `
        <a class="tl-doc ${def.cls}" href="${url}" target="_blank" rel="noopener">
          <span class="tl-docicon">${iconSvg(def.kind)}</span>
          <span class="tl-doctext">
            <span class="tl-doclabel">${def.label}</span>
            <span class="tl-docsub">${def.sub}</span>
          </span>
        </a>
      `;

      const html = defs
        .map(def => {
          const url = safeUrl(files?.[def.key]);
          return url ? item(def, url) : '';
        })
        .filter(Boolean)
        .join('');

      if (!html) return `<div class="tl-docempty">No documents uploaded for this product yet.</div>`;
      return `<div class="tl-docgrid">${html}</div>`;
    }

    function testList(tests) {
      if (!Array.isArray(tests) || tests.length === 0) {
        return `<div class="tl-docempty">No test results available for this product.</div>`;
      }

      const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (m) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[m]));

      return `
        <div class="tl-testlist">
          ${tests.map(t => {
            const name = esc(t?.test_name);
            const standard = esc(t?.standard);
            const result = esc(t?.result_value);
            const rating = esc(t?.rating);
            return `
              <div class="tl-test">
                ${name ? `<div class="tl-testname"><span class="tl-testtitle">${name}</span></div>` : ''}
                ${standard ? `<div class="tl-teststandard">Tested in accordance with ${standard}</div>` : ''}
                ${result ? `<div class="tl-testresult"><strong>Result:</strong> ${result}</div>` : ''}
                ${rating ? `<div class="tl-testrating"><strong>Rating:</strong> ${rating}</div>` : ''}
              </div>
            `;
          }).join('')}
        </div>
      `;
    }

    function showStartState() {
      hasSearch = false;
      filtered = [];
      page = 1;
      if (countEl) countEl.textContent = '';
      if (pagerEl) pagerEl.innerHTML = '';
      if (resultsEl) {
        resultsEl.innerHTML = `
          <div class="tl-empty">
            <p><strong>Start typing to search ${activeName}.</strong></p>
            <p style="opacity:.8;">Enter at least ${MIN_CHARS} character${MIN_CHARS === 1 ? '' : 's'}.</p>
          </div>`;
      }
    }

    function renderPager(totalPages) {
      if (!pagerEl) return;
      pagerEl.innerHTML = '';
      if (totalPages <= 1) return;

      const mkBtn = (label, disabled, onClick) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'button button--secondary';
        b.textContent = label;
        b.disabled = disabled;
        if (disabled) b.style.opacity = '0.5';
        b.addEventListener('click', onClick);
        return b;
      };

      const prev = mkBtn('← Previous', page === 1, () => {
        page--;
        render();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      const next = mkBtn('Next →', page === totalPages, () => {
        page++;
        render();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      const info = document.createElement('span');
      info.className = 'tl-pageinfo';
      info.textContent = `${page} / ${totalPages}`;

      pagerEl.append(prev, info, next);
    }

    function render() {
      if (!hasSearch) return showStartState();
      if (!resultsEl) return;

      resultsEl.innerHTML = '';

      const total = filtered.length;
      const totalPages = Math.max(1, Math.ceil(total / perPage));
      if (page > totalPages) page = totalPages;

      if (countEl) countEl.textContent = `${total} result${total === 1 ? '' : 's'}`;

      const start = (page - 1) * perPage;
      const slice = filtered.slice(start, start + perPage);

      if (!slice.length) {
        resultsEl.innerHTML = `
          <div class="tl-empty">
            <p><strong>No results found.</strong></p>
            <p style="opacity:.8;">Try a different search term.</p>
          </div>`;
        if (pagerEl) pagerEl.innerHTML = '';
        return;
      }

      slice.forEach(p => {
        const imgUrl = normaliseImg(p.image);
        const img = imgUrl
          ? `<img src="${imgUrl}" alt="${p.title}" loading="lazy" decoding="async">`
          : `<div class="tl-ph">NO IMAGE</div>`;

        const vendor = p.vendor ? `<span class="tl-chip">${p.vendor}</span>` : '';
        const type = p.type ? `<span class="tl-chip">${p.type}</span>` : '';

        const contentHtml = (docMode === 'tests')
          ? testList(p.tests || [])
          : docList(p.files || {});

        const row = `
          <div class="tl-item">
            <div class="tl-img">${img}</div>
            <div>
              <a class="tl-title" href="${p.url}">${p.title}</a>
              <div class="tl-meta">${vendor}${type}</div>
              ${contentHtml}
            </div>
          </div>
        `;
        resultsEl.insertAdjacentHTML('beforeend', row);
      });

      renderPager(totalPages);
    }

    function runSearch(term) {
      const list = data[activeKey] || [];
      if (term.length < MIN_CHARS) {
        setLoading(false);
        showStartState();
        return;
      }
      hasSearch = true;
      filtered = list.filter(p => (p.title || '').toLowerCase().includes(term));
      page = 1;
      render();
    }

    // Parse data
    try {
      data = JSON.parse(dataEl?.textContent || '{}') || data;
    } catch (err) {
      console.error('Technical Library JSON error:', err);
      if (resultsEl) resultsEl.innerHTML = `<div class="tl-empty"><p><strong>Library failed to load.</strong></p></div>`;
      return;
    }

    // Tabs
    tabs.forEach(btn => {
      btn.addEventListener('click', () => {
        tabs.forEach(b => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        activeKey = btn.dataset.tab;
        activeName = btn.textContent.trim();
        if (activeLabelEl) activeLabelEl.textContent = activeName;

        const term = (searchEl?.value || '').toLowerCase().trim();
        if (term.length >= MIN_CHARS) runSearch(term);
        else showStartState();
      });
    });

    showStartState();

    // Live search
    let t;
    if (searchEl) {
      searchEl.addEventListener('input', (e) => {
        const term = (e.target.value || '').toLowerCase().trim();
        setLoading(true);
        clearTimeout(t);
        t = setTimeout(() => {
          runSearch(term);
          setLoading(false);
        }, 200);
      });
    }
  }

  function boot(sectionId) {
    initTechnicalLibrary(sectionId);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-tl][data-section-id]').forEach((el) => {
      boot(el.getAttribute('data-section-id'));
    });
  });

  document.addEventListener('shopify:section:load', (e) => {
    const id = e?.detail?.sectionId;
    if (id) boot(id);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const id = e?.detail?.sectionId;
    if (id && window.__TL_INIT__) delete window.__TL_INIT__[id];
  });
})();
